import styled, { css } from 'styled-components'
import { RewardsAmount } from '../../shared_components/Header'
import { Box } from '../../shared_components/UI/Box'
import { defaultTransition } from '../../theme'

export const Container = styled(Box)`
  flex-direction: column;
  padding-bottom: 64px;
`

export const PageToggler = styled(Box)`
  justify-content: flex-start;
  max-width: fit-content;
  position: relative;
  z-index: 10;
  gap: 40px;
  @media screen and (max-width: 850px) {
    flex-direction: column;
    flex-wrap: wrap;
    border-bottom: 1px solid transparent;
    gap: 10px;
  }
`
export const ToggleTitle = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: normal;
  margin-right: 4px;
  text-transform: uppercase;
  width: 100%;
  @media screen and (max-width: 850px) {
    font-size: 14px;
    line-height: 18px;
  }
`

export const Outer = styled(Box)`
  position: relative;
  flex: ${({ flex }) => flex};

  @media screen and (max-width: 850px) {
    margin-right: 27px;
    margin-top: 8px;
  }
`

type ToggleContainerProps = {
  isActive: boolean
  disabled?: boolean
}
export const ToggleContainer = styled(Box)<ToggleContainerProps>`
  padding-bottom: 6px;
  align-items: center;
  cursor: pointer;
  ${defaultTransition}
  filter: saturate(1);
  min-height: 26px;
  padding-bottom: 1rem;
  :after {
    content: '';
    ${defaultTransition}
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: -1px;
    background: ${({ theme }) => theme.colors.brandPrimary};
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  }
  :hover {
    :after {
      ${defaultTransition}
      opacity: 0.8;
    }
  }
  ${({ isActive }) =>
    !isActive &&
    css`
      filter: saturate(0);
      opacity: 0.4;
      ${RewardsAmount} {
        color: black;
      }
      :after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        bottom: -14px;
        background: white;
      }
      :hover {
        :after {
          opacity: 0;
        }
        filter: saturate(1);
        opacity: 1;
      }
    `}
  // @media screen and (max-width: 850px) {
  //   :after {
  //     display: none;
  //   }
  // }
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.3;
    `}
`
